require('./bootstrap');

window.Vue = require('vue');

/**
 * Routes imports and assigning
 */
 import VueRouter from 'vue-router';
 Vue.use(VueRouter);
 import routes from './routes';

 const router = new VueRouter({
     mode: 'history',
     routes,
     linkActiveClass: 'active',
     scrollBehavior: function(to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash, behavior: 'smooth',}
        } else {
            return { x: 0, y: 0 }
        }
    },
 });
 // Routes End


 //Swal

import Swal from 'sweetalert2';


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
window.Swal = Swal;
window.Toast = Toast;


 //Form
import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)


import money from 'v-money'

import kg from 'v-money'

// register directive v-money and component <money>
Vue.use(money, {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: false
})



//COMPONENTES GLOBAIS
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('header-component', require('./components/HeaderComponent.vue').default);
Vue.component('footer-component', require('./components/FooterComponent.vue').default);
Vue.component('cart-component', require('./components/CartComponent.vue').default);
Vue.component('lista-produtos', require('./components/ListaProdutos.vue').default);

Vue.component('drop-down', require('./components/DropDown.vue').default);
Vue.component('modal-add-carrinho', require('./components/ModalAddCarrinho.vue').default);
Vue.component('modal-add-carrinho-pizza', require('./components/ModalAddCarrinhoPizza.vue').default);
Vue.component('modal-add-carrinho-clone', require('./components/ModalAddCarrinhoClone.vue').default);
Vue.component('modal-add-carrinho-clone-pizza', require('./components/ModalAddCarrinhoClonePizza.vue').default);
Vue.component('modal-login', require('./components/ModalLogin.vue').default);
Vue.component('modal-endereco', require('./components/ModalEndereco.vue').default);
Vue.component('modal-finalizar-compra', require('./components/ModalFinalizarCompra.vue').default);
Vue.component('modals-all', require('./components/Modals.vue').default);

Vue.component('detalhes', require('./components/Detalhes.vue').default);

//Componentes Temporarios
Vue.component('fc-tudo-temp', require('./components/ModalFinalizarCompra/TudoTemp.vue').default);
Vue.component('fc-endereco', require('./components/ModalFinalizarCompra/Endereco.vue').default);
Vue.component('fc-pagamento', require('./components/ModalFinalizarCompra/Pagamento.vue').default);
Vue.component('fc-confirmar-dados', require('./components/ModalFinalizarCompra/ConfirmarDados.vue').default);
Vue.component('fc-map', require('./components/ModalFinalizarCompra/Map.vue').default);

import Drawer from './components/Drawer.vue';
Vue.component('Drawer', Drawer);

import store from './vuex/store.js';

// Importar e configurar o plugin vue2-google-maps
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBsbwAlxpJqngu-b6uyHINjFYZxfQ0zplc',
    libraries: 'places,drawing', // This is required if you want to use the drawing library
  },
});

const app = new Vue({
    el: '#app',
    router,
    store,

    created: function () {
        this.$store.dispatch('fetchPerfil').then();
    }
});
